/**
 * もしもアフィリエイト関連のユーティリティ
 */

import { UserId } from '@/core/Profiles'

const createDeleteTag = (el: Element) => () => {
  if (!el) return
  el.remove()
}

/**
 * headにコンバージョンタグを設置する
 */
export const applyConversionTag = (uid: UserId) => {
  const src = `https://r.moshimo.com/af/r/result.js?p_id=3702&pc_id=9049&m_v=${uid}`

  const existing = document.querySelector(`script[src='${src}']`)
  if (existing) {
    return createDeleteTag(existing)
  }

  const script = document.createElement('script')
  script.setAttribute('src', src)
  script.setAttribute('type', 'text/javascript')
  document.body.insertBefore(script, document.body.firstChild)

  return createDeleteTag(script)
}
